module.exports = __webpack_public_path__ + "static/media/game_BGM_v2.1275c325.mp3";